import React, { useEffect, useRef, useState } from "react";
import Select, { StylesConfig } from "react-select";
import ModalComponent from "../../../../core/common/modal/ModalComponent";
import "./Document.css";
// import FolderStructure from './FolderStructure';
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { constantsPermission } from "../../../../Config/Constants";
import TextField from "../../../../core/common/textFields/TextField";
import { usePermission } from "../../../../core/hooks/PermissionHook";
import {
  useCreateCustomFolderMutation,
  useDocumentImagePreviewQuery,
  useGetPermissionsDocumentsQuery,
  useGetProjectFoldersQuery,
  useLazyDocumentImagePreviewQuery,
  useUploadFileMutation,
  useUpsertPermissionDocumentMutation,
} from "../../../../services/EndPointsApis";
import FolderGridView from "./ProjectFolderGridView";
import FolderListView from "./ProjectFolderList";
import FolderTree from "./ProjectFolderTree";
import FolderTree3 from "./ProjectFolderTree3";
import ImageGallery, { ReactImageGalleryItem } from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { PhotoProvider, PhotoSlider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';



const Documents = ({ projectId, projectLookups, viewOnly }: any) => {
  //PermissionHook
  const { permissionList } = usePermission(
    constantsPermission?.moduleId?.documents
  );
  // Find specific permissions
  const createFolderPermission = permissionList?.find(
    (p: any) => p.name === "Create Folder"
  );
  const createFilePermission = permissionList?.find(
    (p: any) => p.name === "Create File"
  );
  const viewFilePermission = permissionList?.find(
    (p: any) => p.name === "View File"
  );
  const editFilePermission = permissionList?.find(
    (p: any) => p.name === "Edit File"
  );

  // Extract `haveaccess` values
  const canCreateFolder = createFolderPermission?.haveaccess ?? false;
  const canCreateFile = createFilePermission?.haveaccess ?? false;
  const viewFilePerm = viewFilePermission?.haveaccess ?? false;
  const editFilePerm = editFilePermission?.haveaccess ?? false;

  //PermissionHook

  const [isLocked, setIsLocked] = useState(null);
  const [selectedParentId, setSelectedParentId] = useState(null);
  const [showfilterModal, setShowfilterModal] = useState(false);
  const [showDocumentrModal, setShowDocumentModal] = useState(false);
  const [showFolderDocumentrModal, setFolderShowDocumentModal] = useState(false);
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [isFile, setIsFile] = useState(false);

  const [gridView, setGridView] = useState({
    value: 1,
    label: "Tree View",
  });
  const [selectedRowId, setSelectedRowId] = useState<any[]>([]);
  const [selectedFolderName, setSelectedFolderName] = useState("");

  const [imgePreview, setImagePreview] = useState("");

  const { data: folderStructureData, refetch } = useGetProjectFoldersQuery({
    ProjectId: projectId,
  });

  const [fileData, setFileData] = useState<File[]>([]);
  //upliad File
  const [uploadFile, { data, isError, error, isSuccess, isLoading }] =
    useUploadFileMutation();

  //api for document permissions
  const { data: permissionData, refetch: refetchPermission } =
    useGetPermissionsDocumentsQuery({ ProjectId: projectId, RoleId: "1" });
  // image preview
  const [triggerImages, { data: imagePreviewData, isFetching: isLoadingImages }] =
    useLazyDocumentImagePreviewQuery();
  //add folder
  const [
    addFolder,
    {
      data: folderData,
      isError: isErrorFolder,
      error: errorFolder,
      isSuccess: isSuccessFolder,
      isLoading: isLoadingFolder
    },
  ] = useCreateCustomFolderMutation();

  //Formik
  const initialValues = {
    projectId: projectId,
    folderId: selectedRowId,
    FolderName: "",
    file: [],
  };

  const formik = useFormik({
    initialValues,
    onSubmit: async (values) => {
      if (!fileData) {
        return toast.error("Please select a file before submitting.");
      }
      const formData = new FormData();
      formData.append("ProjectId", values.projectId.toString());
      formData.append("FolderId", selectedRowId.toString());
      formData.append("FolderName", selectedFolderName.toString());
      fileData.forEach((file, index) => {
        formData.append("files", file);
      });
      try {
        await uploadFile(formData).unwrap();
        toast.success("File uploaded successfully");
        formik.resetForm();
        refetch();
        setShowDocumentModal(false);
        setFileData([])
      } catch (error) { }
    },
  });

  const { resetForm } = formik;

  const handleSubmit = () => {
    formik.handleSubmit();
  };

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = "Something went wrong";

      if (
        "data" in error &&
        error.data &&
        typeof error.data === "object" &&
        "message" in error.data
      ) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  }, [isError, error]);

  //Formik

  const handleShowDocumentModal = () => {
    setShowDocumentModal(true);
  };
  const handleCloseDocumentModal = () => {
    setShowDocumentModal(false);
  };
  // const handleSelect = (id: any) => {
  //   setSelectedRowId(id)
  // };

  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById("dropdownMenuClickable");
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  };
  const options2 = [
    { value: 1, label: "Tree View" },
    { value: 2, label: "List View" },
    { value: 3, label: "Grid View" },
    { value: 4, label: "Tree View (3 levels only)" },
  ];

  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };

  const handleImageChangeFirst = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      setFileData(fileArray);
      formik.setFieldValue("files", fileArray);
    }
  };
  const disable = selectedParentId === null || isLocked === 1 || isFile;
  const disablePreview = selectedRowId === null || selectedRowId.length === 0;

  useEffect(() => {
    refetch();
  }, [refetch]);

  const folderSchema = Yup.object().shape({
    FolderName: Yup.string().required("Folder Name is required"),
  });
  const initialValuesFolder = {
    projectId: projectId,
    folderId: selectedRowId,
    FolderName: "",
  };

  const formik2 = useFormik({
    validationSchema: folderSchema,
    initialValues: initialValuesFolder,
    onSubmit: async (values) => {
      addFolder({ ...values, folderId: selectedRowId });
    },
  });
  const handleCloseFolderModal = () => {
    setFolderShowDocumentModal(false);
  };
  const handleShowFolderModal = () => {
    setFolderShowDocumentModal(true);
  };
  const handleCloseImageModal = () => {
    setShowImagePreview(false);
  };
  const handleShowImageModal = () => {
    setShowImagePreview(true);
    triggerImages({
      ProjectId: projectId,
      folderId: selectedRowId,
    });
  };

  const handleSubmitFolderModal = () => {
    formik2.handleSubmit();
  };

  useEffect(() => {
    if (isSuccessFolder) {
      toast.success(folderData.message);
      formik2.resetForm();
      handleCloseFolderModal();
      refetch();
    }
  }, [isSuccessFolder]);

  useEffect(() => {
    if (isErrorFolder && errorFolder) {
      let errorMessage: string = "Something went wrong";

      if (
        "data" in errorFolder &&
        errorFolder.data &&
        typeof errorFolder.data === "object" &&
        "message" in errorFolder.data
      ) {
        errorMessage = (errorFolder.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  }, [isError, errorFolder]);
  const [decodeImage, setDecodeImage] = useState('')

  const images = imagePreviewData?.result?.map((image: any) => ({
    original: image,
    thumbnail: image,
  }));

  const imageEmbeds = imagePreviewData?.result?.map((image: any, index: any) => {
    return (
      <embed key={index} src={image} />
    );
  });
  const [currentIndex, setCurrentIndex] = useState(0);

  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const imagesData = imagePreviewData?.result || [];

  const galleryRef = useRef<ImageGallery>(null);
  const [loadedImages, setLoadedImages] = useState<{ [key: string]: boolean }>({});

  const handleImageLoad = (src: string) => {
    setLoadedImages((prev) => ({ ...prev, [src]: true }));
  };

  const renderGalleryItem = (item: ReactImageGalleryItem) => {
    const src = item.original ?? "";

    return (
      <div className="image-gallery-slide-wrapper">
        {!loadedImages[src] && <div className="spinner" />}
        <img
          src={src}
          alt=""
          loading="lazy"
          style={{
            display: loadedImages[src] ? "inline" : "none",
            maxHeight: "500px",
            objectFit: "contain"
          }}
          onLoad={() => handleImageLoad(src)}
        />
      </div>
    );
  };

  return (
    <>
      <ModalComponent
        modalTitle={`Upload Files To ${selectedFolderName}`}
        isVisible={showDocumentrModal}
        cancelButton="Cancel"
        onClose={handleCloseDocumentModal}
        saveButton="Upload"
        disabled={fileData.length === 0 || isLoading}
        className="p-2"
        onSave={handleSubmit}
      >
        <>
          <input
            type="file"
            className=""
            onChange={handleImageChangeFirst}
            id="file"
            name="file"
            accept=".png, .jpg, .jpeg, .pdf"
            multiple
            style={{
              border: "2px dashed #ccc",
              borderRadius: "8px",
              padding: "20px",
              textAlign: "center",
              backgroundColor: "#f0f8ff",
              cursor: "pointer",
            }}
          />
        </>
      </ModalComponent>
      <ModalComponent
        modalTitle={`Add Folder To ${selectedFolderName}`}
        isVisible={showFolderDocumentrModal}
        cancelButton="Cancel"
        onClose={handleCloseFolderModal}
        disabled={isLoadingFolder}
        saveButton="Add"
        className="p-2"
        onSave={handleSubmitFolderModal}
      >
        <>
          <TextField
            label="Folder Name"
            required
            type="text"
            placeholder="Enter folder Name"
            {...formik2.getFieldProps("FolderName")}
          />
          {formik2.touched.FolderName && formik2.errors.FolderName && (
            <div className="error">{formik2.errors.FolderName}</div>
          )}
        </>
      </ModalComponent>
      <ModalComponent
        modalTitle={`Preview Images Of ${selectedFolderName}`}
        isVisible={showImagePreview}
        cancelButton="Cancel"
        onClose={handleCloseImageModal}
        className="p-2 modal-xl"
        viewOnly={true}
      >
        <>
          <div>
            {/* <PhotoProvider
              speed={() => 800}
              easing={(type) => (type === 2 ? 'cubic-bezier(0.36, 0, 0.66, -0.56)' : 'cubic-bezier(0.34, 1.56, 0.64, 1)')}
              toolbarRender={({ onScale, scale, rotate, onRotate }) => {
                return (
                  <>
                    <div className="d-flex gap-5 pe-5">
                      <div className="fs-30 fw-800 cursor-pointer" style={{ color: 'white' }} onClick={() => onScale(scale + 1)} >
                        <i className="fa-solid fa-circle-plus"></i>
                      </div>
                      <div className="fs-30 fw-800 cursor-pointer" style={{ color: 'white' }} onClick={() => onScale(scale - 1)} >
                        <i className="fa-solid fa-circle-minus"></i>
                      </div>
                      <div className="fs-30 fw-800 cursor-pointer" style={{ color: 'white' }} onClick={() => onRotate(rotate + 90)}  >
                        <i className="fa-solid fa-rotate-right"></i>
                      </div>

                    </div>
                  </>
                );
              }}
            >
              <Swiper spaceBetween={10} slidesPerView={1} pagination={{ clickable: true }}>
                {imagePreviewData?.result?.map((img: string, index: number) => (
                  <SwiperSlide key={index}>
                    <PhotoView src={img}>
                      <img
                        src={img}
                        alt={`Image ${index + 1}`}
                        className="h-60 max-w-full w-auto object-contain cursor-pointer mx-auto"
                      />
                    </PhotoView>
                  </SwiperSlide>
                ))}
              </Swiper>
            </PhotoProvider> */}
            {isLoadingImages ? (
              <div className="text-center">Loading Images......</div>
            ) : imagesData?.length > 0 ? (
              <>
                <ImageGallery
                  ref={galleryRef}
                  items={imagesData.map((item: any) => ({
                    original: item,
                    thumbnail: item,
                  }))}
                  lazyLoad={true}
                  showPlayButton={false}
                  showFullscreenButton={false}
                  disableSwipe={true}
                  onSlide={(index) => setCurrentIndex(index)}
                  onClick={() => {
                    setIndex(currentIndex);
                    setVisible(true);
                  }}
                  renderItem={renderGalleryItem}
                />

                <PhotoSlider
                  images={imagesData.map((item: any) => ({ src: item }))}
                  visible={visible}
                  index={index}
                  loadingElement={<div className="loading" />}
                  onIndexChange={setIndex}
                  onClose={() => setVisible(false)}
                  toolbarRender={({ onScale, scale, rotate, onRotate }) => {
                    return (
                      <div className="d-flex gap-5 pe-5">
                        <div
                          className="fs-30 fw-800 cursor-pointer"
                          style={{ color: 'white' }}
                          onClick={() => onScale(scale + 1)}
                        >
                          <i className="fa-solid fa-circle-plus"></i>
                        </div>
                        <div
                          className="fs-30 fw-800 cursor-pointer"
                          style={{ color: 'white' }}
                          onClick={() => onScale(scale - 1)}
                        >
                          <i className="fa-solid fa-circle-minus"></i>
                        </div>
                        <div
                          className="fs-30 fw-800 cursor-pointer"
                          style={{ color: 'white' }}
                          onClick={() => onRotate(rotate + 90)}
                        >
                          <i className="fa-solid fa-rotate-right"></i>
                        </div>
                      </div>
                    );
                  }}
                />
              </>
            ) : (
              <div className="text-center">No Data Found</div>
            )}

          </div>
        </>
      </ModalComponent>
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="card main-card">
              <div className="card-body">
                {/* Search */}
                <div className="row">
                  <div className="d-flex justify-content-end">
                    <div className="col-md-8 col-sm-12">
                      <div className="d-flex justify-content-end gap-3">
                        <div className="d-flex align-items-center gap-2">
                          <p className="mb-0">Select Folder View:</p>{" "}
                          <Select
                            styles={customStyles}
                            className="select"
                            options={options2}
                            value={
                              gridView?.label
                                ? {
                                  value: gridView?.value,
                                  label: gridView?.label,
                                }
                                : null
                            }
                            onChange={(selectedOption: any) => {
                              setGridView(selectedOption);
                            }}
                          />
                        </div>
                        {/* <button className="btn btn-transparent border-0" disabled={disable}><span className='me-2'>{svgIcons.downloadIcon}</span>Download</button> */}
                        <button
                          className="btn btn-primary"
                          onClick={handleShowImageModal}
                          disabled={disablePreview}
                        >
                          Preview
                        </button>

                        {canCreateFolder && (
                          <button
                            className="btn btn-primary"
                            onClick={handleShowFolderModal}
                            disabled={disable || viewOnly}
                          >
                            + Create Folder
                          </button>
                        )}
                        {canCreateFile && (
                          <button
                            className="btn btn-primary"
                            onClick={handleShowDocumentModal}
                            disabled={disable || viewOnly}
                          >
                            + Upload Documents
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* treeview folder structure */}
                {gridView?.value === 1 && (
                  <div className="folder-structure">
                    <FolderTree
                      folders={folderStructureData}
                      setSelectedRowId={setSelectedRowId}
                      setSelectedFolderName={setSelectedFolderName}
                      setSelectedParentId={setSelectedParentId}
                      setIsLocked={setIsLocked}
                      setIsFile={setIsFile}
                      viewFilePerm={viewFilePerm}
                      editFilePerm={editFilePerm}
                    />
                  </div>
                )}
                {gridView?.value === 2 && (
                  <div>
                    <FolderListView
                      folders={folderStructureData}
                      setSelectedRowId={setSelectedRowId}
                      setSelectedFolderName={setSelectedFolderName}
                      setSelectedParentId={setSelectedParentId}
                      setIsLocked={setIsLocked}
                      setIsFile={setIsFile}
                      viewFilePerm={viewFilePerm}
                      editFilePerm={editFilePerm}
                    />
                  </div>
                )}
                {gridView?.value === 3 && (
                  <div>
                    <FolderGridView
                      folders={folderStructureData}
                      setSelectedRowId={setSelectedRowId}
                      setSelectedFolderName={setSelectedFolderName}
                      setSelectedParentId={setSelectedParentId}
                      setIsLocked={setIsLocked}
                      setIsFile={setIsFile}
                      viewFilePerm={viewFilePerm}
                      editFilePerm={editFilePerm}
                    />
                  </div>
                )}
                {gridView?.value === 4 && (
                  <div>
                    <FolderTree3
                      uploadFile={uploadFile}
                      folders={folderStructureData}
                      setSelectedRowId={setSelectedRowId}
                      setSelectedFolderName={setSelectedFolderName}
                      setSelectedParentId={setSelectedParentId}
                      setIsLocked={setIsLocked}
                      setIsFile={setIsFile}
                      viewFilePerm={viewFilePerm}
                      editFilePerm={editFilePerm}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Documents;
